import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import parse from "html-react-parser";
import * as Yup from "yup";
import { Form } from "react-bootstrap";
import AWS from "aws-sdk";
import {
  createMonteChatBotCompletion,
  createTextToSpeechCompletion,
  getStarPilotMonteChatO3Mini,
  getStarPilotMonteTextReply,
  getStarPilotMonteChatHistory,
} from "../api/apiHandler";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import queryString from "query-string";
import "react-h5-audio-player/lib/styles.css";
import chatLoader from "../assets/chatloader.gif";
import talkto from "../assets/talkto.png";
import constantFunc from "../constant/constantFunc";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button } from "react-bootstrap";
import pdficon from "../assets/pdf.png";
import txtIcon from "../assets/txtIcon.png";
import docIcon from "../assets/doc.png";
import xlsxIcon from "../assets/xlsx.jpg";
import { Brightness1 } from "@material-ui/icons";
import constant from "../constant/constant";
import styled from "styled-components";
import AutoPrescriptionPopup from "./footer/Common/AutoPrescriptionPopup";

const StarpilotChat = ({
  invite,
  setInvite,
  guest,
  buttonClick,
  screenShareBtn,
  handleScreenShare,
  handleScreenShareBtn,
  videoBtn,
  videoTiles,
  handleOtherUserJoin,
  leaveBtn,
  leaveMeeting,
  autoPrescMain,
  audioStatus,
  handleAudio,
  callCreated,
  setChat,
  chat,
  meetingid,
}) => {
  const location = useParams();
  const audioRef = useRef(null);
  const fileInputRef = useRef(null);
  const [pocType, setPocType] = useState(location.poc_type);
  const [conversation, setConversation] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [optionSelected, setOptionSelected] = useState(false);
  const [loadingChat, setLoadingChat] = useState(false);
  const [activeChat, setActiveChat] = useState(false);
  const [instruction] = useState(constant?.auto_rx_instruction);
  const [audible, setAudible] = useState(true);
  const [image, setImage] = useState("");
  const [fileType, setFileType] = useState(null);
  const [showChat, setShowChat] = useState(true);
  const [uploadImage, setUploadImage] = useState(null);
  const [searchTextValue, setSearchTextValue] = useState("");
  const [timeoutId, setTimeoutId] = useState(null);

  const [loadingSpeaker, setLoadingSpeaker] = useState({
    status: false,
    index: "",
  });
  const [audioData, setAudioData] = useState({
    url: "",
    text: "",
    playStatus: false,
  });
  const [uuid, setUuid] = useState("");
  // console.log("uuid usestae", uuid);
  const [isNewchat, setIsNewChat] = useState(1);
  const [handleSweetAlert, setHandleSweetAlert] = useState(true);
  const [showListeningModal, setListeningModal] = useState(false);
  const [handleStartStopListening, setStartStopListening] = useState(true);
  const [intervalId, setIntervalId] = useState(null);
  const { interimTranscript, resetTranscript, transcript, listening } =
    useSpeechRecognition();

  const validationSchema = Yup.object().shape({
    prompt: Yup.string().required("prompt is required"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, formState, reset, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  // useEffect(() => {
  //   // localStorage.setItem("monteChatId", data.profile_image);
  //   if (localStorage.getItem("monteChatId")) {
  //     setUuid(localStorage.getItem("monteChatId"));
  //     setIsNewChat(0)
  //     chatCreateMonteChatCompletion("Hello", localStorage.getItem("monteChatId"), "data")

  //   } else {
  //     setIsNewChat(1)
  //     generateUuidIfEmpty()
  //   }

  //   // showSweetAlert()
  // }, [])

  const checkNoResponse = () => {
    // Clear previous timeout if any
    if (timeoutId) clearTimeout(timeoutId);

    const id = setTimeout(() => {
      // setConversation((prev) => [
      //   "I can't hear you, please say something or ask for help",
      //   ...prev,
      // ]);
      setAudible(false);
      console.log(
        "No response detected, showing 'I can't hear you...' message."
      );
      // checkNoResponse();
    }, 40000); // 30 seconds timeout

    setTimeoutId(id);
  };

  useEffect(() => {
    try {
      getStarPilotMonteChatHistory({ meeting_id: meetingid }).then(
        async (res) => {
          // console.log('response===>', res)
          var response = JSON.parse(res);
          console.log("response===>", response.data.response);
          if (response.code == process.env.REACT_APP_SUCCESS) {
            if (response.data.response && response.data.response.length > 0) {
              // let newMsgT = await constantFunc.convertMarkdownLinksToHTML(response.data.response)
              setConversation((prev) => [...response.data.response, ...prev]);
            }
            console.log("responseData-->", response);
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: response.message,
              toast: true,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      );
    } catch (error) {}
  }, []);

  const emptyImage = async () => {
    try {
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input field
      }
      console.log("empyimage");
      setImage("");
      setUploadImage(null);
      setFileType("");
    } catch (error) {}
  };

  console.log("setFileType-->", fileType);
  const onImageChange = (event) => {
    console.log("event00<", event);
    if (event.target.files && event.target.files[0]) {
      console.log("event.target.files[0]==>", event.target.files[0]);
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (allowedTypes.includes(event.target.files[0].type)) {
        const fileSizeLimit = 10 * 1024 * 1024;
        if (event.target.files[0].size > fileSizeLimit) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "File size exceeds the limit of 10 MB",
            toast: true,
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          console.log("test");
          setImage(URL.createObjectURL(event.target.files[0]));
          setUploadImage(event.target.files[0]);
          if (event.target.files[0].type == "application/pdf") {
            setFileType("pdf");
          } else if (event.target.files[0].type == "text/plain") {
            setFileType("text");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            setFileType("doc");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            setFileType("xlsx");
          } else {
            setFileType("image");
          }
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title:
            "Only Image File(png, jpeg, jpg, PDF, Text, docx, xlsx) Type Allowed!",
          toast: true,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }
  };

  const uploadData = async (file, folder_type) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + folder_type,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };
      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadData:", error);
    }
  };

  useEffect(() => {
    // If isActive is true, start the interval
    if (
      activeChat &&
      parseInt(localStorage.getItem("user_login_type_role")) == 2
    ) {
      const id = setInterval(() => {
        chatCreateMonteChatCompletion();
      }, 10000); // 10 seconds

      setIntervalId(id); // Store the interval ID
      checkNoResponse();
      // Cleanup function to clear the interval
      return () => {
        clearInterval(id);
        setIntervalId(null); // Reset intervalId to null
      };
    } else if (parseInt(localStorage.getItem("user_login_type_role")) == 3) {
      const id = setInterval(() => {
        getStarPilotMonteChatHistory({ meeting_id: meetingid }).then(
          async (res) => {
            // console.log('response===>', res)
            var response = JSON.parse(res);
            console.log("response===>", response.data.response);
            if (response.code == process.env.REACT_APP_SUCCESS) {
              if (response.data.response && response.data.response.length > 0) {
                // let newMsgT = await constantFunc.convertMarkdownLinksToHTML(response.data.response)
                setConversation((prev) => [...response.data.response, ...prev]);
              }
              console.log("responseData-->", response);
            }
          }
        );
      }, 10000); // 10 seconds
      setIntervalId(id); // Store the interval ID
      // Cleanup function to clear the interval
      return () => {
        clearInterval(id);
        setIntervalId(null); // Reset intervalId to null
      };
    }
  }, [activeChat]);
  const onSubmitBtn = async (data) => {
    try {
      console.log("onSubmitBtn", data);
      setActiveChat(data);
    } catch (e) {
      console.log("error-->", e);
    }
  };

  const handleAudioEnd = () => {
    // console.log('Audio has ended');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    // Add any additional logic you want to execute when audio ends here
  };

  const stopAudio = () => {
    // console.log('Audio has Stoped');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    audioRef.current.pause();
    audioRef.current.currentTime = 0; // Resets audio to the start
  };

  const resetChat = () => {
    const newUuid = uuidv4();
    console.log("Generated uuid:", isNewchat);
    setUuid(newUuid);
    localStorage.setItem("monteChatId", newUuid);
    chatCreateMonteChatCompletion("Hello", newUuid, 1);
  };
  console.log("Generated uuid:", isNewchat);
  // useEffect(() => {
  //   let timeoutId;
  //   if (optionSelected) {
  //     timeoutId = setTimeout(() => {
  //       if (!searchValue.trim()) {
  //         Swal.fire({
  //           title: 'Please make a request',
  //           icon: 'warning',
  //         });
  //       }
  //     }, 60000);
  //   }

  //   return () => clearTimeout(timeoutId);
  // }, [searchValue]);

  useEffect(() => {
    // if (optionSelected) {
    // chatCreateMonteChatCompletion("Hello", uuid)
    // }
  }, []);

  const generateUuidIfEmpty = () => {
    if (!uuid) {
      // const newUuid = randtoken.generate(16, "abcdefghijklnmopqrstuvwxyz");
      const newUuid = uuidv4();
      // console.log("Generated uuid:", newUuid);
      setUuid(newUuid);
      localStorage.setItem("monteChatId", newUuid);
      setTimeout(() => {
        // Swal.fire({
        //   title: 'Please wait...',
        //   didOpen: () => {
        //     Swal.showLoading()
        //   }
        // })

        chatCreateMonteChatCompletion("Hello", newUuid);
      }, 500);
    }
  };

  const showSweetAlert = () => {
    Swal.fire({
      title: `Hello ${localStorage.getItem("user_name")}, How are you today?`,
      imageUrl: `${process.env.PUBLIC_URL + "/assets/images/logo.png"}`,
      imageWidth: 150,
      imageHeight: 120,
      showCancelButton: true,
      confirmButtonText: "I'm feeling great",
      cancelButtonText: "I'm doing okay",
    }).then((result) => {
      setHandleSweetAlert(false);
      if (result.isConfirmed) {
        handleOptionSelection("Option 1");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        handleOptionSelection("Option 2");
      }
    });
  };

  const pocCreateTextToSpeechCompletion = (msg, key) => {
    // Swal.fire({
    //   title: 'Please wait...',
    //   didOpen: () => {
    //     Swal.showLoading()
    //   }
    // })
    // console.log("fff", audioData?.text, "ff", key)
    if (audioData?.text && audioData?.text == msg) {
      setAudioData((prev) => ({ ...prev, playStatus: true }));
      audioRef.current.src = audioData?.url;
      audioRef.current.controls = true;
      audioRef.current.play();
    } else {
      setLoadingSpeaker({
        status: true,
        index: key,
      });
      createTextToSpeechCompletion({ text: msg }).then((res) => {
        // console.log('response===>', res)
        var response = JSON.parse(res);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          const arrayBuffer = response.data.buffer.data;
          // console.log("arrayBuffer==>", arrayBuffer)
          // Convert buffer data to Blob
          const byteArray = new Uint8Array(arrayBuffer);
          const blob = new Blob([byteArray], { type: "audio/mpeg" });
          // const blob = new Blob([arrayBuffer], { type: 'audio/mp3' });
          const url = URL.createObjectURL(blob);
          // setAudioSrc(url)
          // const audio = new Audio(url);
          // console.log("url==>", url)
          if (audioRef.current) {
            // console.log("test")
            audioRef.current.src = url;
            audioRef.current.controls = true;
            audioRef.current.play();
            setAudioData({
              url: url,
              text: msg,
              playStatus: true,
            });
          } else {
            // console.log("testfsed")
          }
        } else {
          // Swal.fire({
          //   position: 'top-end',
          //   icon: 'error',
          //   title: response.message,
          //   toast: true,
          //   showConfirmButton: false,
          //   timer: 2000
          // })
        }
        if (!handleSweetAlert) {
          // Swal.close()
        }
        setLoadingSpeaker({
          status: false,
          index: "",
        });
      });
    }
  };

  const handleOptionSelection = (option) => {
    // console.log(`User selected option: ${option}`);
    setOptionSelected(true);
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
  };

  const chatCreateMonteChatCompletion = () => {
    setLoadingChat(true);
    getStarPilotMonteChatO3Mini({ meeting_id: meetingid }).then(async (res) => {
      // console.log('response===>', res)
      var response = JSON.parse(res);
      console.log("response===>", response.data.response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setIsNewChat(0);
        if (response.data.response) {
          let newMsgT = await constantFunc.convertMarkdownLinksToHTML(
            response.data.response
          );
          console.log(
            "response.data.chatHistory-->",
            response.data.chatHistory
          );
          if (
            response?.data?.chatHistory &&
            response?.data?.chatHistory.length > 0
          ) {
            setConversation((prev) => [...response.data.chatHistory, ...prev]);
          } else {
            setConversation((prev) => [newMsgT, ...prev]);
          }
          setAudible(true);
          checkNoResponse();
        }
        setSearchValue("");
        reset();
        console.log("responseData-->", response);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      setLoadingChat(false);
    });
  };

  const chatCreateMonteChatTextReply = (data) => {
    setLoadingChat(true);
    console.log("meeting_id", data);
    getStarPilotMonteTextReply({
      meeting_id: data?.meeting_id,
      prompt: data?.prompt || "",
      imgUrl: data.imgUrl || "",
      imgType: data.imgType || "",
    }).then(async (res) => {
      // console.log('response===>', res)
      var response = JSON.parse(res);
      console.log("response===>", response.data.response);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input field
      }
      setImage("");
      setUploadImage(null);
      setFileType("");
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setIsNewChat(0);
        if (response.data.response) {
          let newMsgT = await constantFunc.convertMarkdownLinksToHTML(
            response.data.response
          );
          setConversation((prev) => [newMsgT, ...prev]);
        }
        setSearchValue("");
        reset();
        console.log("responseData-->", response);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      setLoadingChat(false);
    });
  };

  const autoPresc = async () => {
    try {
      const meetingDataObj = {
        uuid: uuid,
      };
      const serializedObject = queryString.stringify(meetingDataObj);
      const url = `/patient/auto-prescription-poc?${serializedObject}`;
      setTimeout(() => {
        window.open(url, "_blank");
      }, 500);
    } catch (error) {}
  };

  const openListeningModal = () => {
    setListeningModal(true);
  };

  const closeListeningModal = () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    setStartStopListening(true);
    setListeningModal(false);
    setValue("prompt", searchValue, { shouldValidate: false });
  };

  const handleListening = () => {
    if (handleStartStopListening) {
      SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
      setStartStopListening(false);
    } else {
      // SpeechRecognition.stopListening();
      // resetTranscript()
      // setStartStopListening(true)
      closeListeningModal();
    }
  };
  const onSubmitChat = async () => {
    console.log("searchTextValue--->", searchTextValue);
    // chatCreateMonteChatCompletion(searchTextValue, uuid)
    if (searchTextValue || uploadImage) {
      const chatGptObj = {
        meeting_id: meetingid,
        prompt: searchTextValue,
      };
      if (uploadImage) {
        console.log("data: ");
        let imgUrl = "";
        await uploadData(uploadImage, "/analysis_file")
          .then((newImage) => {
            Swal.close();
            console.log("newImagenewImagenewImage", newImage);
            imgUrl = newImage;
          })
          .catch((e) => {
            Swal.close();
          });
        chatGptObj.imgUrl = `https://msh-dev.s3.amazonaws.com/analysis_file/${imgUrl}`;
        chatGptObj.imgType = fileType;
      }
      console.log("chatGptObj-->", chatGptObj);
      chatCreateMonteChatTextReply(chatGptObj);
    }
    setSearchTextValue("");
  };

  useEffect(() => {
    let timeout;
    if (transcript) {
      // console.log('transcript: ', transcript);
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setSearchValue(transcript);
      }, 1000);
    } else {
      // console.log("transscrpt functirn calluued");
    }
    return () => clearTimeout(timeout);
  }, [transcript, resetTranscript]);

  return (
    <>
      <div
        className={`${chat && "w-100"} position-fixed search-sec`}
        style={{
          bottom: 10,
          right: 10,
          zIndex: 999999,
          maxWidth: "calc(100% - 30px)",
        }}
      >
        {chat && (
          <>
            <div
              className="chatMain bg-light shadow"
              style={{ borderRadius: 20 }}
            >
              <div
                className="top d-flex align-items-center justify-content-center p-3 "
                style={{
                  background: "#216fc8",
                  borderTopLeftRadius: 20,
                  borderTopRightRadius: 20,
                }}
              >
                <div
                  className="flex-shrink-0 imgWrp me-3 d-flex align-items-center                                        justify-content-center bg-white rounded-circle"
                  style={{ height: 100, width: 100 }}
                >
                  {/* <img src={talkto} style={{}} alt="" className="img-fluid rounded object-fit-contain h-100" /> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_26_398)">
                      <path
                        d="M37.1771 17.2987C38.257 17.141 39.3183 16.9652 40.3858 16.8348C43.7624 16.419 47.165 16.2427 50.5673 16.3071C54.1396 16.384 57.7014 16.7185 61.2239 17.3078C61.5478 17.3624 61.5324 17.5353 61.5324 17.7566C61.5046 19.3486 61.4799 20.9406 61.4398 22.5296C61.4263 22.6546 61.4458 22.7809 61.4966 22.8962C61.5475 23.0115 61.6278 23.1119 61.7298 23.1876C66.5028 27.1116 68.9926 32.1575 69.008 38.2495C69.0761 42.8613 67.4458 47.3418 64.4174 50.8652C61.3891 54.3885 57.167 56.7172 52.5293 57.4218C47.8917 58.1265 43.1512 57.1597 39.1817 54.6996C35.2123 52.2395 32.2814 48.452 30.9294 44.0353C28.8592 37.1973 30.2599 30.9961 34.8632 25.5074C35.4706 24.8301 36.1208 24.191 36.81 23.594C36.9034 23.519 36.9781 23.424 37.0284 23.3162C37.0787 23.2085 37.1032 23.0908 37.1 22.9723C37.1 21.3106 37.1278 19.6367 37.1463 17.9841C37.1494 17.7748 37.1648 17.5595 37.1771 17.2987ZM36.125 29.2282C32.0093 34.7411 31.9044 44.2506 38.7074 50.3033C40.2843 51.705 42.1289 52.7846 44.134 53.4795C46.1391 54.1744 48.2648 54.4706 50.3874 54.351C52.51 54.2313 54.5873 53.6982 56.4984 52.7826C58.4096 51.867 60.1165 50.5872 61.52 49.0176C67.3821 42.5798 66.4565 33.5524 62.3808 28.652C61.6797 29.351 60.9424 30.0139 60.1718 30.6382C58.0553 32.1938 55.5747 32.7609 53.0016 32.9914C50.4296 33.1951 47.8426 33.1168 45.2883 32.7579L44.6219 32.6669C44.7178 32.5906 44.833 32.5414 44.9551 32.5244C46.4577 32.1271 47.9787 31.7814 49.4627 31.3114C50.4766 31.0153 51.3916 30.4584 52.113 29.6982C52.3789 29.366 52.6231 29.0176 52.8442 28.655C52.6128 28.6823 52.5357 28.6884 52.474 28.7005C51.1905 28.9643 49.9101 29.2585 48.6205 29.4859C45.8992 29.962 43.1533 30.244 40.392 29.9529C38.9728 29.8104 37.5813 29.4799 36.125 29.2282Z"
                        fill="#216fc8"
                      ></path>
                      <path
                        d="M37.3635 57.0746C41.144 67.2776 44.9142 77.4523 48.6741 87.5986L48.6093 87.6441C48.5353 87.5592 48.452 87.4804 48.3841 87.3894L33.1582 67.5485C32.6553 66.8965 32.1462 66.2506 31.6619 65.5865C31.6208 65.5219 31.596 65.4485 31.5896 65.3726C31.5831 65.2966 31.5952 65.2203 31.6248 65.1498C33.476 62.4783 35.3704 59.8189 37.2462 57.1565C37.2821 57.125 37.3214 57.0975 37.3635 57.0746Z"
                        fill="#216fc8"
                      ></path>
                      <path
                        d="M61.8267 57.02C62.2926 57.672 62.7091 58.2542 63.1225 58.8395C64.5634 60.8894 65.9949 62.9483 67.4419 64.9891C67.4898 65.0396 67.5269 65.0989 67.5512 65.1636C67.5754 65.2284 67.5863 65.2972 67.5831 65.3661C67.5799 65.435 67.5628 65.5026 67.5328 65.5649C67.5027 65.6272 67.4603 65.683 67.408 65.7291C64.4873 69.5216 61.5706 73.3181 58.6581 77.1187L50.7536 87.4137C50.7237 87.4593 50.6848 87.4986 50.6392 87.5293C50.5937 87.5601 50.5424 87.5816 50.4883 87.5926C54.2647 77.428 58.0318 67.2665 61.8267 57.02Z"
                        fill="#216fc8"
                      ></path>
                      <path
                        d="M61.3261 16.1979C53.4149 14.9432 45.352 14.9207 37.4336 16.1312C37.4067 16.0481 37.3871 15.9629 37.375 15.8765C37.375 14.988 37.375 14.1025 37.375 13.1473C38.1772 13.0503 38.9979 12.9411 39.8186 12.8441C44.9249 12.2944 50.0709 12.1929 55.1956 12.5408C57.1147 12.6712 59.0245 12.9199 60.9404 13.1018C61.249 13.1321 61.3415 13.2322 61.3353 13.5294C61.3137 14.3997 61.3261 15.2669 61.3261 16.1979Z"
                        fill="#216fc8"
                      ></path>
                      <path
                        d="M50.9035 69.662C50.8919 70.031 50.7378 70.3819 50.4724 70.6432C50.2071 70.9046 49.8504 71.0568 49.475 71.069C49.0985 71.0564 48.7417 70.9003 48.4803 70.6337C48.2189 70.3671 48.0732 70.011 48.0743 69.6407C48.073 69.4578 48.1089 69.2764 48.18 69.1073C48.251 68.9382 48.3557 68.7847 48.4879 68.6559C48.6201 68.5271 48.7772 68.4256 48.9498 68.3572C49.1225 68.2889 49.3074 68.2551 49.4935 68.258C49.8696 68.2612 50.2292 68.4107 50.4934 68.6738C50.7577 68.937 50.9051 69.2923 50.9035 69.662Z"
                        fill="#216fc8"
                      ></path>
                      <path
                        d="M50.9355 75.1598C50.9447 75.5296 50.805 75.8881 50.5467 76.1572C50.2885 76.4264 49.9326 76.5845 49.5564 76.5972C49.1813 76.5935 48.822 76.4476 48.5536 76.19C48.2852 75.9324 48.1283 75.5829 48.1156 75.2144C48.1073 74.8449 48.2485 74.4873 48.5083 74.2201C48.768 73.9529 49.125 73.7979 49.5009 73.7892C49.687 73.7851 49.8721 73.8175 50.0454 73.8845C50.2187 73.9515 50.3767 74.0516 50.5102 74.1792C50.6437 74.3068 50.7501 74.4592 50.8231 74.6275C50.8961 74.7959 50.9344 74.9768 50.9355 75.1598Z"
                        fill="#216fc8"
                      ></path>
                      <path
                        d="M49.4979 62.5086C49.6859 62.5106 49.8716 62.549 50.0445 62.6215C50.2174 62.6941 50.3741 62.7994 50.5056 62.9315C50.6371 63.0635 50.7409 63.2197 50.8109 63.3912C50.881 63.5627 50.916 63.746 50.914 63.9308C50.912 64.1156 50.8729 64.2982 50.7991 64.4681C50.7253 64.6381 50.6182 64.7921 50.4838 64.9213C50.3494 65.0505 50.1905 65.1525 50.016 65.2214C49.8416 65.2903 49.655 65.3247 49.467 65.3227C49.0873 65.3187 48.7248 65.1666 48.4593 64.8999C48.1937 64.6331 48.0468 64.2737 48.0509 63.9005C48.055 63.5273 48.2097 63.171 48.4811 62.91C48.7524 62.649 49.1182 62.5046 49.4979 62.5086Z"
                        fill="#216fc8"
                      ></path>
                      <path
                        d="M36.125 29.2282C37.5812 29.4829 38.9727 29.8104 40.3827 29.959C43.1594 30.2622 45.8899 29.959 48.6111 29.492C49.9008 29.2646 51.1812 28.9704 52.4647 28.7066C52.5325 28.7066 52.6035 28.6884 52.8349 28.6611C52.6138 29.0237 52.3696 29.3721 52.1037 29.7043C51.3823 30.4645 50.4673 31.0214 49.4534 31.3175C47.9694 31.7814 46.4484 32.1271 44.9458 32.5304C44.8237 32.5474 44.7085 32.5967 44.6126 32.673L45.279 32.7639C47.8333 33.1228 50.4203 33.2011 52.9923 32.9974C55.5654 32.7609 58.046 32.1999 60.1625 30.6443C60.9331 30.02 61.6704 29.357 62.3715 28.6581C66.4472 33.5554 67.3697 42.5859 61.5107 49.0236C60.1072 50.5933 58.4003 51.8731 56.4891 52.7887C54.578 53.7043 52.5007 54.2374 50.3781 54.357C48.2555 54.4767 46.1298 54.1804 44.1247 53.4856C42.1196 52.7907 40.275 51.711 38.6981 50.3094C31.9043 44.2506 32.0092 34.7411 36.125 29.2282ZM58.1231 47.5832C58.0521 47.559 58.0367 47.5469 58.0244 47.5499C57.9565 47.5711 57.8855 47.5893 57.8176 47.6166C57.1244 47.908 56.3722 48.0384 55.6194 47.9979C54.8666 47.9575 54.1334 47.7471 53.4766 47.3831C52.7362 46.9859 52.0235 46.5431 51.2861 46.1338C51.0187 45.9534 50.7125 45.836 50.3915 45.7908C50.0705 45.7456 49.7431 45.7737 49.4349 45.873C49.3259 45.9092 49.2077 45.9092 49.0986 45.873C48.85 45.7849 48.5848 45.7513 48.3216 45.7743C48.0583 45.7974 47.8034 45.8766 47.5745 46.0064C46.8865 46.3733 46.217 46.7797 45.5413 47.1769C44.0233 48.0624 42.456 48.2928 40.7714 47.6287C40.6807 47.5981 40.5879 47.5738 40.4938 47.5559C41.4348 48.3561 42.5171 48.98 43.687 49.3966C45.1248 49.8818 46.5471 49.9152 47.9293 49.2298C48.4075 48.9933 48.8549 48.681 49.3023 48.399C49.3133 48.3953 49.3252 48.3953 49.3362 48.399C49.4658 48.493 49.5923 48.59 49.7219 48.681C50.3047 49.1278 50.979 49.4454 51.6985 49.6118C52.418 49.7783 53.1657 49.7897 53.8901 49.6453C55.4852 49.3451 56.8304 48.5839 58.1231 47.5832Z"
                        fill="transparent"
                      ></path>
                      <path
                        d="M58.1229 47.5832C56.8301 48.5687 55.4849 49.345 53.9022 49.6483C53.1778 49.7927 52.4301 49.7813 51.7106 49.6148C50.9911 49.4484 50.3168 49.1308 49.734 48.6839C49.6044 48.593 49.4779 48.4959 49.3483 48.4019C49.3373 48.3982 49.3254 48.3982 49.3144 48.4019C48.8547 48.6839 48.4196 49.0084 47.9414 49.2328C46.5592 49.9181 45.1369 49.8848 43.6991 49.3996C42.5292 48.983 41.4469 48.3591 40.5059 47.5589C40.6 47.5767 40.6928 47.6011 40.7835 47.6317C42.4558 48.2958 44.0354 48.0653 45.5534 47.1799C46.2291 46.7826 46.8986 46.3763 47.5866 46.0094C47.8155 45.8796 48.0704 45.8003 48.3337 45.7773C48.5969 45.7543 48.8621 45.7879 49.1107 45.876C49.2198 45.9122 49.338 45.9122 49.447 45.876C49.7552 45.7767 50.0826 45.7486 50.4036 45.7938C50.7247 45.839 51.0308 45.9564 51.2982 46.1367C52.0356 46.5461 52.7483 46.9888 53.4888 47.3861C54.1455 47.75 54.8787 47.9604 55.6315 48.0009C56.3843 48.0414 57.1365 47.9109 57.8298 47.6196C57.8976 47.5923 57.9686 47.5741 58.0365 47.5529C58.0365 47.5468 58.0519 47.5589 58.1229 47.5832Z"
                        fill="#216fc8"
                      ></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_26_398">
                        <rect
                          width="39.0011"
                          height="75.3125"
                          fill="transparent"
                          transform="translate(29.998 12.3438)"
                        ></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div
                  className="content text-center"
                  style={{ fontFamily: "Aharoni" }}
                >
                  <h2
                    className="m-0 fw-bold text-white"
                    style={{ fontSize: 50, lineHeight: "40px" }}
                  >
                    StarPilot
                  </h2>
                  <h5 className="m-0 text-white">Concierge</h5>
                </div>
              </div>
              <div className="p-3" style={{ fontSize: 12 }}>
                <div className="form-horizontal m-t-30 position-relative">
                  {loadingChat && (
                    <img
                      src={chatLoader}
                      style={{ left: 10, top: 20, height: 20 }}
                      alt=""
                      className="img-fluid position-absolute"
                    />
                  )}
                  <div
                    className="container py-3 border rounded-3"
                    style={{ maxWidth: 600 }}
                  >
                    <StarpilotCTA className="d-flex gap-2">
                      {/* <div className="input-group p-1 rounded">
                        <span className="input-group-text d-flex align-items-center justify-content-center p-0" style={{ fontSize: 12, height: 30, width: 30 }} id="basic-addon1">
                          <i className="fa-solid fa-magnifying-glass"> </i>
                        </span>
                        <input
                          type="text"
                          style={{ fontSize: 12 }}
                          name="prompt"
                          className="form-control"
                          id="prompt"
                          placeholder=" Send your message..."
                          value={searchValue}
                          onChange={(e) => { setSearchValue(e.target.value) }}
                          disabled={loadingChat}
                        />
                        <div className="invalid-feedback" />
                      </div> */}
                      <div className="d-flex align-items-center  flex-wrap justify-content-between w-100 ">
                        <div
                          className="d-flex gap-2 status"
                          style={{ alignItems: "center" }}
                        >
                          {/* <button
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Send" disabled={loadingChat} className="search-btn p-2 rounded" onClick={onSubmitChat} type="button">
                          <img src="/assets/images/icon/send1.svg" alt="search" />
                        </button>
                        <button data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="mike" disabled={loadingChat} onClick={openListeningModal} className="search-btn p-2 rounded" type="button">
                          <img
                            src="/assets/images/icon/mdi_microphone.svg"
                            alt="microphone"
                          />
                        </button>
                        <button type="button"
                          onClick={() => {
                            setIsNewChat(1);
                            resetChat()
                          }}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Start Again" className="search-btn p-2 rounded"  >
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2V4C10.0845 4.00022 8.23272 4.6877 6.78115 5.93749C5.32958 7.18727 4.37462 8.9164 4.08983 10.8106C3.80504 12.7048 4.20934 14.6382 5.22923 16.2596C6.24912 17.881 7.81691 19.0826 9.64763 19.646C11.4783 20.2095 13.4505 20.0974 15.2055 19.3301C16.9606 18.5628 18.3821 17.1913 19.2117 15.4648C20.0413 13.7382 20.2239 11.7714 19.7262 9.9217C19.2286 8.07199 18.0839 6.46223 16.5 5.385V8H14.5V2H20.5V4H18C19.2425 4.93093 20.251 6.13866 20.9453 7.52734C21.6397 8.91601 22.0008 10.4474 22 12Z" fill="#fff" />
                          </svg>
                        </button> */}
                          <label
                            htmlFor="custom-switch"
                            className="d-block mb-0 p-0 nav-link active"
                          >
                            Status
                          </label>
                          <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            onChange={(x) => onSubmitBtn(x.target.checked)}
                            checked={activeChat}
                          />
                        </div>
                        <div
                          className="right d-flex flex-wrap justify-content-center align-items-center gap-10 meeting-widgets"
                          style={{ flex: "unset" }}
                        >
                          {activeChat && (
                            <p className="m-0 fw-sbold">
                              Listening{" "}
                              <img
                                src={chatLoader}
                                style={{ height: 20 }}
                                alt=""
                                className="img-fluid"
                              />
                            </p>
                          )}
                          {!callCreated ? (
                            ""
                          ) : (
                            <div
                              className="mute-widget"
                              style={{ background: "#216fc8" }}
                            >
                              <i
                                className={
                                  audioStatus
                                    ? "fa-solid fa-microphone"
                                    : "fa-solid fa-microphone-slash"
                                }
                                onClick={handleAudio}
                              />
                            </div>
                          )}
                          {!callCreated ? (
                            ""
                          ) : (
                            <div
                              className="mute-widget"
                              style={{ background: "#216fc8" }}
                            >
                              <i
                                className={"fa-solid fa-plus"}
                                onClick={handleOtherUserJoin}
                              />
                            </div>
                          )}

                          {videoTiles && (
                            <>
                              <div
                                className="mute-widget"
                                style={{ background: "#216fc8" }}
                              >
                                <i
                                  className={
                                    videoBtn
                                      ? "fa-solid fa-video"
                                      : "fa-solid fa-video-slash"
                                  }
                                  onClick={buttonClick}
                                />
                              </div>
                              <div
                                className="mute-widget"
                                style={{ background: "#216fc8" }}
                              >
                                {handleScreenShareBtn ? (
                                  <img
                                    src="/assets/images/icon/desktop.png"
                                    style={{
                                      height: 20,
                                      filter: "brightness(500)",
                                    }}
                                    disabled={!screenShareBtn}
                                    onClick={handleScreenShare}
                                  />
                                ) : (
                                  <img
                                    src="/assets/images/icon/desktop-slash.png"
                                    className="img-fluid object-fit-contain"
                                    style={{
                                      height: 20,
                                      filter: "brightness(500)",
                                    }}
                                    disabled={!screenShareBtn}
                                    onClick={handleScreenShare}
                                  />
                                )}
                              </div>
                            </>
                          )}
                          {callCreated ? (
                            <AutoPrescriptionPopup
                              instruction={instruction}
                              onConfirm={autoPrescMain}
                            />
                          ) : (
                            ""
                          )}
                          {callCreated &&
                          !guest &&
                          localStorage.getItem("user_login_type_role") == 2 ? (
                            <div
                              onClick={() => setInvite(!invite)}
                              className="mute-widget"
                              style={{ background: "#216fc8" }}
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 17V19H7V17C7 17 7 13 13 13C19 13 19 17 19 17ZM16 8C16 7.40666 15.8241 6.82664 15.4944 6.33329C15.1648 5.83994 14.6962 5.45542 14.1481 5.22836C13.5999 5.0013 12.9967 4.94189 12.4147 5.05764C11.8328 5.1734 11.2982 5.45912 10.8787 5.87868C10.4591 6.29824 10.1734 6.83279 10.0576 7.41473C9.94189 7.99667 10.0013 8.59987 10.2284 9.14805C10.4554 9.69623 10.8399 10.1648 11.3333 10.4944C11.8266 10.8241 12.4067 11 13 11C13.7956 11 14.5587 10.6839 15.1213 10.1213C15.6839 9.55871 16 8.79565 16 8ZM19.2 13.06C19.7466 13.5643 20.1873 14.1724 20.4964 14.8489C20.8054 15.5254 20.9766 16.2566 21 17V19H24V17C24 17 24 13.55 19.2 13.06ZM18 5C17.6979 5.00002 17.3976 5.04725 17.11 5.14C17.6951 5.97897 18.0087 6.97718 18.0087 8C18.0087 9.02282 17.6951 10.021 17.11 10.86C17.3976 10.9527 17.6979 11 18 11C18.7956 11 19.5587 10.6839 20.1213 10.1213C20.6839 9.55871 21 8.79565 21 8C21 7.20435 20.6839 6.44129 20.1213 5.87868C19.5587 5.31607 18.7956 5 18 5ZM8 10H5V7H3V10H0V12H3V15H5V12H8V10Z"
                                  fill="#fff"
                                />
                              </svg>
                            </div>
                          ) : (
                            ""
                          )}

                          <button
                            className={
                              leaveBtn ? "leave-btn" : "leave-btn-disable"
                            }
                            onClick={leaveBtn ? leaveMeeting : undefined}
                            disabled={!leaveBtn}
                          >
                            Leave
                          </button>
                        </div>
                      </div>
                    </StarpilotCTA>
                  </div>
                  {/* <div className="container pt-3 pb-2">
                    <div className="d-flex gap-2">
                      <div className="input-group p-1 rounded">
                        <span className="input-group-text d-flex align-items-center justify-content-center p-0" style={{ fontSize: 12, height: 30, width: 30 }} id="basic-addon1">
                          <i className="fa-solid fa-magnifying-glass"> </i>
                        </span>
                        <input
                          type="text"
                          style={{ fontSize: 12 }}
                          name="prompt"
                          className="form-control"
                          id="prompt"
                          placeholder=" Send your message..."
                          value={searchValue}
                          onChange={(e) => { setSearchValue(e.target.value) }}
                          disabled={loadingChat}
                        />
                        <div className="invalid-feedback" />
                      </div>
                      <div className="d-flex gap-2 status">
                        <button
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Send" disabled={loadingChat} className="search-btn p-2 rounded" onClick={onSubmitChat} type="button">
                          <img src="/assets/images/icon/send1.svg" alt="search" />
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div
                  className="ans-block overflow-auto border-0"
                  style={{ maxHeight: "calc(-310px + 100vh)" }}
                >
                  {/* {activeChat && ()} */}
                  {/* input */}
                  {parseInt(localStorage.getItem("user_login_type_role")) ==
                    2 && (
                    <>
                      <div className=" py-3">
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <div
                            className="position-relative p-3 rounded w-100"
                            style={{
                              border: "2px dashed #9d9d9d",
                              maxWidth: 400,
                            }}
                          >
                            {image && (
                              <Button
                                onClick={emptyImage}
                                className="border-0 position-absolute text-white  rounded-circle p-2 d-flex align-items-center justify-content-center"
                                style={{
                                  top: 0,
                                  right: 0,
                                  zIndex: 999,
                                  transform: "translateY(-50%)",
                                  background: "#216fc8",
                                  height: 30,
                                  width: 30,
                                }}
                                variant="transparent"
                              >
                                X
                              </Button>
                            )}
                            <input
                              type="file"
                              ref={fileInputRef}
                              onChange={onImageChange}
                              style={{
                                left: 0,
                                top: 0,
                                zIndex: 99,
                                opacity: 0,
                              }}
                              className="position-absolute h-100 w-100 file"
                            />
                            <div className="text-center">
                              {image && (
                                <img
                                  src={
                                    (fileType == "pdf" && pdficon) ||
                                    (fileType == "text" && txtIcon) ||
                                    (fileType == "doc" && docIcon) ||
                                    (fileType == "xlsx" && xlsxIcon) ||
                                    image
                                  }
                                  alt=""
                                  className="img-fluid mx-auto object-fit-contain"
                                  style={{ height: 100, width: 100 }}
                                />
                              )}
                              <p className="m-0 text-muted">Upload File</p>
                              <p
                                className="m-0 text-muted"
                                style={{ fontSize: 10 }}
                              >
                                Upload File for Analysis
                              </p>
                            </div>
                          </div>
                          {/* <button className="search-btn" type="button" onClick={onSubmit12}>
                <img src={process.env.PUBLIC_URL + "/assets/images/icon/send1.svg"} alt="search" />
              </button> */}
                        </div>
                      </div>
                      {/* End  input */}
                      {/* chat button */}
                      <div className="d-flex gap-2">
                        <div className="input-group mb-3">
                          <span className="input-group-text" id="basic-addon1">
                            <i className="fa-solid fa-magnifying-glass"> </i>
                          </span>
                          <input
                            type="text"
                            {...register("prompt")}
                            className="form-control"
                            id="prompt"
                            value={searchTextValue}
                            placeholder={
                              parseInt(location.poc_type) == 7
                                ? "Hello I have a fever and a headache and some fatigue. What might be the problem? what do you need for accurate differential diagnosis?"
                                : parseInt(location.poc_type) == 2
                                ? "Please check the following prescription for interactions and indications. Please revise the prescription to remove interactions and ameliorate severe indications."
                                : " Send your message..."
                            }
                            onChange={(e) => {
                              setSearchTextValue(e.target.value);
                            }}
                          />
                          <div className="invalid-feedback">
                            {errors.prompt?.message}
                          </div>
                          {activeChat && !audible && (
                            <>
                              <div className="invalid-feedback">
                                {
                                  "I can't hear you, please say something or ask for help"
                                }
                              </div>
                            </>
                          )}
                        </div>
                        <div className="d-flex gap-2">
                          <button
                            className="search-btn"
                            type="button"
                            onClick={onSubmitChat}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/icon/send1.svg"
                              }
                              alt="search"
                            />
                          </button>
                        </div>
                      </div>
                      {/*  end chat button */}
                    </>
                  )}

                  <div
                    className="textmessageWrpper"
                    // style={{ maxHeight: "calc(-310px + 100vh)" }}
                  >
                    <div className="ans-sub-block border-0">
                      {conversation.map((entry, index) => (
                        <div key={index}>
                          {/* {entry.is_new_chat == 0 ?
                        <div className="que-block px-0">

                          <img src={(localStorage.getItem("profile_image")) || "../assets/images/user-dummy.png"} alt="profile" className="profile" />

                          <div>
                            <p className='m-0 font_16 text-blue font_600 '>You</p>
                            <p className="mb-0">{entry.prompt}</p>
                          </div>
                        </div> : ""} */}
                          <div className="bg-[#040404] rounded-lg  mb-2 overflow-auto subblock">
                            <div className="aiicon">
                              <img
                                src="/assets/images/logo.png"
                                alt="profile"
                                className="profile"
                              />
                            </div>
                            <div>
                              <p className="mb-2 font_16 text-blue font_600">
                                StarPilot
                              </p>
                              <pre className="mb-2 text-justify white-space-pre">
                                {parse(entry)}
                              </pre>
                              {(loadingSpeaker?.status &&
                                loadingSpeaker?.index == index + 1 && (
                                  <img
                                    src="../assets/images/speakerLoader.gif"
                                    style={{ height: "47px" }}
                                    alt=""
                                    className="img-fluid"
                                  />
                                )) ||
                                (audioData?.playStatus &&
                                  audioData?.text == parse(entry) && (
                                    <button
                                      className="search-btn"
                                      type="button"
                                      onClick={() => {
                                        stopAudio();
                                      }}
                                    >
                                      <i className="fa-solid fa-pause text-white" />
                                    </button>
                                  )) || (
                                  <button
                                    className="search-btn"
                                    type="button"
                                    onClick={() => {
                                      pocCreateTextToSpeechCompletion(
                                        parse(entry),
                                        index + 1
                                      );
                                    }}
                                  >
                                    <i className="fa-solid fa-volume-up text-white" />
                                  </button>
                                )}

                              <audio
                                onEnded={handleAudioEnd}
                                style={{ height: 0, width: 0, opacity: 0 }}
                                ref={audioRef}
                                controls
                              >
                                <source src="" type="audio/mpeg" />
                              </audio>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <button
          onClick={() => {
            setAudioData((prev) => ({ ...prev, playStatus: false }));
            setChat(!chat);
          }}
          className="d-flex align-items-center rounded-circle justify-content-center  position-fixed shadow"
          style={{
            bottom: 10,
            right: 10,
            zIndex: 999999,
            height: 60,
            width: 60,
            background: "#216fc8",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
          >
            <g clip-path="url(#clip0_26_398)">
              <path
                d="M37.1771 17.2987C38.257 17.141 39.3183 16.9652 40.3858 16.8348C43.7624 16.419 47.165 16.2427 50.5673 16.3071C54.1396 16.384 57.7014 16.7185 61.2239 17.3078C61.5478 17.3624 61.5324 17.5353 61.5324 17.7566C61.5046 19.3486 61.4799 20.9406 61.4398 22.5296C61.4263 22.6546 61.4458 22.7809 61.4966 22.8962C61.5475 23.0115 61.6278 23.1119 61.7298 23.1876C66.5028 27.1116 68.9926 32.1575 69.008 38.2495C69.0761 42.8613 67.4458 47.3418 64.4174 50.8652C61.3891 54.3885 57.167 56.7172 52.5293 57.4218C47.8917 58.1265 43.1512 57.1597 39.1817 54.6996C35.2123 52.2395 32.2814 48.452 30.9294 44.0353C28.8592 37.1973 30.2599 30.9961 34.8632 25.5074C35.4706 24.8301 36.1208 24.191 36.81 23.594C36.9034 23.519 36.9781 23.424 37.0284 23.3162C37.0787 23.2085 37.1032 23.0908 37.1 22.9723C37.1 21.3106 37.1278 19.6367 37.1463 17.9841C37.1494 17.7748 37.1648 17.5595 37.1771 17.2987ZM36.125 29.2282C32.0093 34.7411 31.9044 44.2506 38.7074 50.3033C40.2843 51.705 42.1289 52.7846 44.134 53.4795C46.1391 54.1744 48.2648 54.4706 50.3874 54.351C52.51 54.2313 54.5873 53.6982 56.4984 52.7826C58.4096 51.867 60.1165 50.5872 61.52 49.0176C67.3821 42.5798 66.4565 33.5524 62.3808 28.652C61.6797 29.351 60.9424 30.0139 60.1718 30.6382C58.0553 32.1938 55.5747 32.7609 53.0016 32.9914C50.4296 33.1951 47.8426 33.1168 45.2883 32.7579L44.6219 32.6669C44.7178 32.5906 44.833 32.5414 44.9551 32.5244C46.4577 32.1271 47.9787 31.7814 49.4627 31.3114C50.4766 31.0153 51.3916 30.4584 52.113 29.6982C52.3789 29.366 52.6231 29.0176 52.8442 28.655C52.6128 28.6823 52.5357 28.6884 52.474 28.7005C51.1905 28.9643 49.9101 29.2585 48.6205 29.4859C45.8992 29.962 43.1533 30.244 40.392 29.9529C38.9728 29.8104 37.5813 29.4799 36.125 29.2282Z"
                fill="#fff"
              ></path>
              <path
                d="M37.3635 57.0746C41.144 67.2776 44.9142 77.4523 48.6741 87.5986L48.6093 87.6441C48.5353 87.5592 48.452 87.4804 48.3841 87.3894L33.1582 67.5485C32.6553 66.8965 32.1462 66.2506 31.6619 65.5865C31.6208 65.5219 31.596 65.4485 31.5896 65.3726C31.5831 65.2966 31.5952 65.2203 31.6248 65.1498C33.476 62.4783 35.3704 59.8189 37.2462 57.1565C37.2821 57.125 37.3214 57.0975 37.3635 57.0746Z"
                fill="#fff"
              ></path>
              <path
                d="M61.8267 57.02C62.2926 57.672 62.7091 58.2542 63.1225 58.8395C64.5634 60.8894 65.9949 62.9483 67.4419 64.9891C67.4898 65.0396 67.5269 65.0989 67.5512 65.1636C67.5754 65.2284 67.5863 65.2972 67.5831 65.3661C67.5799 65.435 67.5628 65.5026 67.5328 65.5649C67.5027 65.6272 67.4603 65.683 67.408 65.7291C64.4873 69.5216 61.5706 73.3181 58.6581 77.1187L50.7536 87.4137C50.7237 87.4593 50.6848 87.4986 50.6392 87.5293C50.5937 87.5601 50.5424 87.5816 50.4883 87.5926C54.2647 77.428 58.0318 67.2665 61.8267 57.02Z"
                fill="#fff"
              ></path>
              <path
                d="M61.3261 16.1979C53.4149 14.9432 45.352 14.9207 37.4336 16.1312C37.4067 16.0481 37.3871 15.9629 37.375 15.8765C37.375 14.988 37.375 14.1025 37.375 13.1473C38.1772 13.0503 38.9979 12.9411 39.8186 12.8441C44.9249 12.2944 50.0709 12.1929 55.1956 12.5408C57.1147 12.6712 59.0245 12.9199 60.9404 13.1018C61.249 13.1321 61.3415 13.2322 61.3353 13.5294C61.3137 14.3997 61.3261 15.2669 61.3261 16.1979Z"
                fill="#fff"
              ></path>
              <path
                d="M50.9035 69.662C50.8919 70.031 50.7378 70.3819 50.4724 70.6432C50.2071 70.9046 49.8504 71.0568 49.475 71.069C49.0985 71.0564 48.7417 70.9003 48.4803 70.6337C48.2189 70.3671 48.0732 70.011 48.0743 69.6407C48.073 69.4578 48.1089 69.2764 48.18 69.1073C48.251 68.9382 48.3557 68.7847 48.4879 68.6559C48.6201 68.5271 48.7772 68.4256 48.9498 68.3572C49.1225 68.2889 49.3074 68.2551 49.4935 68.258C49.8696 68.2612 50.2292 68.4107 50.4934 68.6738C50.7577 68.937 50.9051 69.2923 50.9035 69.662Z"
                fill="#fff"
              ></path>
              <path
                d="M50.9355 75.1598C50.9447 75.5296 50.805 75.8881 50.5467 76.1572C50.2885 76.4264 49.9326 76.5845 49.5564 76.5972C49.1813 76.5935 48.822 76.4476 48.5536 76.19C48.2852 75.9324 48.1283 75.5829 48.1156 75.2144C48.1073 74.8449 48.2485 74.4873 48.5083 74.2201C48.768 73.9529 49.125 73.7979 49.5009 73.7892C49.687 73.7851 49.8721 73.8175 50.0454 73.8845C50.2187 73.9515 50.3767 74.0516 50.5102 74.1792C50.6437 74.3068 50.7501 74.4592 50.8231 74.6275C50.8961 74.7959 50.9344 74.9768 50.9355 75.1598Z"
                fill="#fff"
              ></path>
              <path
                d="M49.4979 62.5086C49.6859 62.5106 49.8716 62.549 50.0445 62.6215C50.2174 62.6941 50.3741 62.7994 50.5056 62.9315C50.6371 63.0635 50.7409 63.2197 50.8109 63.3912C50.881 63.5627 50.916 63.746 50.914 63.9308C50.912 64.1156 50.8729 64.2982 50.7991 64.4681C50.7253 64.6381 50.6182 64.7921 50.4838 64.9213C50.3494 65.0505 50.1905 65.1525 50.016 65.2214C49.8416 65.2903 49.655 65.3247 49.467 65.3227C49.0873 65.3187 48.7248 65.1666 48.4593 64.8999C48.1937 64.6331 48.0468 64.2737 48.0509 63.9005C48.055 63.5273 48.2097 63.171 48.4811 62.91C48.7524 62.649 49.1182 62.5046 49.4979 62.5086Z"
                fill="#fff"
              ></path>
              <path
                d="M36.125 29.2282C37.5812 29.4829 38.9727 29.8104 40.3827 29.959C43.1594 30.2622 45.8899 29.959 48.6111 29.492C49.9008 29.2646 51.1812 28.9704 52.4647 28.7066C52.5325 28.7066 52.6035 28.6884 52.8349 28.6611C52.6138 29.0237 52.3696 29.3721 52.1037 29.7043C51.3823 30.4645 50.4673 31.0214 49.4534 31.3175C47.9694 31.7814 46.4484 32.1271 44.9458 32.5304C44.8237 32.5474 44.7085 32.5967 44.6126 32.673L45.279 32.7639C47.8333 33.1228 50.4203 33.2011 52.9923 32.9974C55.5654 32.7609 58.046 32.1999 60.1625 30.6443C60.9331 30.02 61.6704 29.357 62.3715 28.6581C66.4472 33.5554 67.3697 42.5859 61.5107 49.0236C60.1072 50.5933 58.4003 51.8731 56.4891 52.7887C54.578 53.7043 52.5007 54.2374 50.3781 54.357C48.2555 54.4767 46.1298 54.1804 44.1247 53.4856C42.1196 52.7907 40.275 51.711 38.6981 50.3094C31.9043 44.2506 32.0092 34.7411 36.125 29.2282ZM58.1231 47.5832C58.0521 47.559 58.0367 47.5469 58.0244 47.5499C57.9565 47.5711 57.8855 47.5893 57.8176 47.6166C57.1244 47.908 56.3722 48.0384 55.6194 47.9979C54.8666 47.9575 54.1334 47.7471 53.4766 47.3831C52.7362 46.9859 52.0235 46.5431 51.2861 46.1338C51.0187 45.9534 50.7125 45.836 50.3915 45.7908C50.0705 45.7456 49.7431 45.7737 49.4349 45.873C49.3259 45.9092 49.2077 45.9092 49.0986 45.873C48.85 45.7849 48.5848 45.7513 48.3216 45.7743C48.0583 45.7974 47.8034 45.8766 47.5745 46.0064C46.8865 46.3733 46.217 46.7797 45.5413 47.1769C44.0233 48.0624 42.456 48.2928 40.7714 47.6287C40.6807 47.5981 40.5879 47.5738 40.4938 47.5559C41.4348 48.3561 42.5171 48.98 43.687 49.3966C45.1248 49.8818 46.5471 49.9152 47.9293 49.2298C48.4075 48.9933 48.8549 48.681 49.3023 48.399C49.3133 48.3953 49.3252 48.3953 49.3362 48.399C49.4658 48.493 49.5923 48.59 49.7219 48.681C50.3047 49.1278 50.979 49.4454 51.6985 49.6118C52.418 49.7783 53.1657 49.7897 53.8901 49.6453C55.4852 49.3451 56.8304 48.5839 58.1231 47.5832Z"
                fill="transparent"
              ></path>
              <path
                d="M58.1229 47.5832C56.8301 48.5687 55.4849 49.345 53.9022 49.6483C53.1778 49.7927 52.4301 49.7813 51.7106 49.6148C50.9911 49.4484 50.3168 49.1308 49.734 48.6839C49.6044 48.593 49.4779 48.4959 49.3483 48.4019C49.3373 48.3982 49.3254 48.3982 49.3144 48.4019C48.8547 48.6839 48.4196 49.0084 47.9414 49.2328C46.5592 49.9181 45.1369 49.8848 43.6991 49.3996C42.5292 48.983 41.4469 48.3591 40.5059 47.5589C40.6 47.5767 40.6928 47.6011 40.7835 47.6317C42.4558 48.2958 44.0354 48.0653 45.5534 47.1799C46.2291 46.7826 46.8986 46.3763 47.5866 46.0094C47.8155 45.8796 48.0704 45.8003 48.3337 45.7773C48.5969 45.7543 48.8621 45.7879 49.1107 45.876C49.2198 45.9122 49.338 45.9122 49.447 45.876C49.7552 45.7767 50.0826 45.7486 50.4036 45.7938C50.7247 45.839 51.0308 45.9564 51.2982 46.1367C52.0356 46.5461 52.7483 46.9888 53.4888 47.3861C54.1455 47.75 54.8787 47.9604 55.6315 48.0009C56.3843 48.0414 57.1365 47.9109 57.8298 47.6196C57.8976 47.5923 57.9686 47.5741 58.0365 47.5529C58.0365 47.5468 58.0519 47.5589 58.1229 47.5832Z"
                fill="#fff"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0_26_398">
                <rect
                  width="39.0011"
                  height="75.3125"
                  fill="transparent"
                  transform="translate(29.998 12.3438)"
                ></rect>
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
      {showListeningModal && (
        <>
          <div
            className={`modal fade ${showListeningModal ? "show" : ""}`}
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
            tabIndex="-1"
            style={{ display: showListeningModal ? "block" : "none" }}
          >
            <div className="modal-dialog prescription-modal modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Listening
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={closeListeningModal}
                  />
                </div>
                <div className="modal-body">
                  <div className="text-center">
                    {!handleStartStopListening ? (
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/icons8-sound.gif"
                        }
                        alt="search"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <div className="d-flex gap-3">
                        <pre className="mb-2 mt-3 text-justify white-space-pre">{searchValue}</pre>
                      </div> */}
                </div>
                <div className="modal-footer">
                  {/* <button type="button" className="btn btn-secondary" onClick={handleListening}>{handleStartStopListening ? "Start" : "Stop"}</button> */}
                  <button
                    type="button"
                    className="btn submit-btn font_18"
                    onClick={handleListening}
                  >
                    {handleStartStopListening ? "Start" : "Stop"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
};

const StarpilotCTA = styled.div`
  @media (max-width: 600px) {
    > div {
      justify-content: center !important;
    }
    .right {
      > p {
        width: 100%;
        text-align: center;
      }
    }
  }
`;

export default StarpilotChat;
